module.exports = __webpack_public_path__ + "img/qiyewx.61fd2848.png";